import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
// import { sha256 } from "js-sha256";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  // Input,
  // FormGroup,
  // Label,
} from "reactstrap";
import LoaderButton from "../../components/CustomButton/LoaderButton";
import { useTranslation } from "react-i18next";
import {
  updatePassword,
  resetChangePassword,
} from "../../redux/actions/changePasswordAction";
import Button from "../../components/CustomButton/CustomButton.jsx";
import val from "../../getThemeDetails";
import Loader from "../Loader/Loader";
import { useSelector, useDispatch } from "react-redux";
import { InputAdornment, IconButton, FormControl, InputLabel, Input, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// import {
//   InputAdornment,
//   IconButton,
//   FormControl,
//   InputLabel,
//   Input,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

function ChangePassword({
  cPasswordModalOpen,
  toggleModal,
  login,
  updatePassword,
  changePassword,
  resetChangePassword,
}) {
  const [passwords, setPasswords] = useState({
    oldPassword: "",
    newPassword: "",
    conPassword: "",
  });

  const [hidePasswords, setHidePasswords] = useState({});
  const [message, setMessage] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [mesColor, setMesColor] = useState("danger");
  const { t } = useTranslation();

  const handleChange = ({ target: { name, value } }) => {
    setPasswords({ ...passwords, [name]: value });
  };

  const regenerateTokenRes = useSelector(
    ({ regenerateToken }) => regenerateToken
  );

    const getPartnerLogin = useSelector(({ login }) => login);
    console.log("getPartnerLogin",getPartnerLogin)
  // console.log("regenerateTokenRes", regenerateTokenRes);
  var authToken = regenerateTokenRes.data.AuthToken;

  const togglePasswords = ({ currentTarget }) => {
    const name = currentTarget.getAttribute("name");
    setHidePasswords((state) => ({
      ...state,
      [name]: !state[name],
    }));
  };

  console.log("chnage", changePassword.data)
  useEffect(() => {
    if (changePassword.data.responseCode == "48") {
      setMessage("Invalid Password");

    }
  }, [changePassword])

  // useEffect(() => {
  //   if (Object.keys(changePassword.data).length > 0) {
  //     if (changePassword.invalidStrength) {
  //       setMessage("Password does not meet requirements");
  //     } else if (changePassword.success) {
  //       setMessage("Password changed successfully");
  //       setMesColor("success");
  //     }


  //   }
  // }, [changePassword]);

     // Effect to handle messages based on changePassword API response
  useEffect(() => {
    if (changePassword && Object.keys(changePassword.data).length > 0) {
      if (changePassword.failed) {
        if (changePassword.data.responseCode === "2") {
          setMessage(changePassword.data.description); // Set message from status
          setMesColor("danger");
        } else {
          // setMessage("Old password is incorrect");
          setMesColor("danger");
        }
      } else if (changePassword.invalidStrength) {
        setMessage("Password does not meet requirements");
        setMesColor("danger");
      } else if (changePassword.success) {
        setMessage("Password changed successfully");
        setMesColor("success");
        // Optionally close modal or clear fields on success
        // setPasswords({ oldPassword: "", newPassword: "", conPassword: "" });
        // toggleModal();
      }
      setSpinner(false); // Always stop spinner once a response is received
    }
  }, [changePassword]);

  useEffect(() => {
    return () => {
      resetChangePassword();
    };
  }, []);

  const handleUpdate = async () => {
    setSpinner(true);
    // const verificationHash = sha256(
    //   login.data.secKey +
    //   login.data.customerId +
    //   passwords.oldPassword +
    //   passwords.newPassword
    // );

    const req = {
      authentication: {
        partnerId: getPartnerLogin?.data?.partnerId,
      },
      ChangePassword: {
        oldPassword: passwords.oldPassword,
        newPassword: passwords.newPassword,
        confirmPassword: passwords.newPassword,
      },
    };

    if (passwords.conPassword === passwords.newPassword) {
      await updatePassword(req, authToken).then(setMessage(""));
    } else {
      setMessage("Password did not match, try again!");
    }
  };

  const value = changePassword.isLoading ? (
    <Loader spinner={spinner} />
  ) : (
    t("Update")
  );

  const disabledButton = () => {
    return !(
      passwords.oldPassword.length > 0 &&
      passwords.newPassword.length > 0 &&
      passwords.conPassword.length > 0
    );
    //return !(passwords.length > 0)
  };

  // let show = <i className="fa fa-eye" />;
  // let hide = <i className="fa fa-eye-slash" />;

  return (
    <>
      <div>
        <Modal
          isOpen={cPasswordModalOpen}
          toggle={toggleModal}
          className="password-modal"
        >
          <ModalHeader toggle={toggleModal}>{t("Change Password")}</ModalHeader>
          <ModalBody
            className="password-modal-body"
            style={{ padding: "0 18px" }}
          >
            {/* <FormGroup>
            <Label for="oldPassword" className="fs-14">
              {t("Enter old password")}
            </Label>
            <Input
              type={hidePasswords.hideOldPassword ? "text" : "password"}
              name="oldPassword"
              value={passwords.oldPassword}
              onChange={handleChange}
            />
            <span
              className="password-icon"
              name="hideOldPassword"
              onClick={togglePasswords}
            >
              {" "}
              {!hidePasswords.hideOldPassword ? hide : show}
            </span>
          </FormGroup> */}
            <FormControl required fullWidth style={{ margin: "15px 0" }}>
              {/* <InputLabel htmlFor="oldPassword">
                {t("Enter old password")}
              </InputLabel> */}
              <TextField
                autoComplete="off"
                // helperText="(Enter old password)"
                placeholder="Enter old password"

                type={hidePasswords.hideOldPassword ? "text" : "password"}
                id="oldPassword"
                name="oldPassword"
                value={passwords.oldPassword}
                onChange={handleChange}
                required
                // endAdornment={
                //   <InputAdornment position="end">
                //     <IconButton
                //       aria-label="toggle password visibility"
                //       onClick={togglePasswords}
                //       onMouseDown={togglePasswords}
                //       name="hideOldPassword"
                //     >
                //       {hidePasswords.hideOldPassword ? (
                //         <Visibility />
                //       ) : (
                //         <VisibilityOff />
                //       )}
                //     </IconButton>
                //   </InputAdornment>
                // }

                
                InputProps={{
                  endAdornment: (
                   <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={togglePasswords}
                      onMouseDown={togglePasswords}
                      name="hideOldPassword"
                    >
                      {hidePasswords.hideOldPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            {/* <FormGroup>
            <Label for="newPassword" className="fs-14">
              {t("Enter new password")}
            </Label>
            <Input
              type={hidePasswords.hideNewPassword ? "text" : "password"}
              name="newPassword"
              value={passwords.newPassword}
              onChange={handleChange}
            />
            <span
              className="password-icon"
              name="hideNewPassword"
              onClick={togglePasswords}
            >
              {" "}
              {!hidePasswords.hideNewPassword ? hide : show}
            </span>
          </FormGroup> */}

            <FormControl required fullWidth style={{ margin: "15px 0" }}>
              {/* <InputLabel htmlFor="newPassword">
                {t("Enter new password")}
              </InputLabel> */}
              <TextField
                helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
                autoComplete="off"
                type={hidePasswords.hideNewPassword ? "text" : "password"}
                id="newPassword"
                name="newPassword"
                placeholder="Enter new password"
                value={passwords.newPassword}
                onChange={handleChange}
                required
                error={
                  (passwords.newPassword.length > 0 && passwords.newPassword.length < 8) ? (
                    <p className="passwordNotMatch" style={{ color: "red" }}>
                      {passwords.newPassword.length > 0
                        ? "Password should be at least 8 characters"
                        : ""}
                    </p>
                  ) : (
                    ""
                  )
                }
                // endAdornment={
                //   <InputAdornment position="end">
                //     <IconButton
                //       aria-label="toggle password visibility"
                //       onClick={togglePasswords}
                //       onMouseDown={togglePasswords}
                //       name="hideNewPassword"
                //     >
                //       {hidePasswords.hideNewPassword ? (
                //         <Visibility />
                //       ) : (
                //         <VisibilityOff />
                //       )}
                //     </IconButton>
                //   </InputAdornment>
                // }

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePasswords}
                        onMouseDown={togglePasswords}
                        name="hideNewPassword"
                      >
                        {hidePasswords.hideNewPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            {/* <FormGroup>
            <Label for="conPassword" className="fs-14">
              {t("Re-enter new password")}
            </Label>
            <Input
              type={hidePasswords.hideConfPassword ? "text" : "password"}
              name="conPassword"
              value={passwords.conPassword}
              onChange={handleChange}
            />
            <span
              className="password-icon"
              name="hideConfPassword"
              onClick={togglePasswords}
            >
              {" "}
              {!hidePasswords.hideConfPassword ? hide : show}
            </span>
          </FormGroup> */}

            <FormControl required fullWidth style={{ margin: "15px 0" }}>
              {/* <InputLabel htmlFor="conPassword">
                {t("Re-enter new password")}
              </InputLabel> */}
              <TextField
                type={hidePasswords.hideConfPassword ? "text" : "password"}
                id="conPassword"
                name="conPassword"
                value={passwords.conPassword}
                onChange={handleChange}
                placeholder="Re-enter new password"
                required
                helperText="(Should be same as Password)"
                error={
                  passwords &&
                    passwords.newPassword !== passwords.conPassword &&
                    passwords.conPassword ? (
                    <p
                      className="passwordNotMatch"
                      style={{ color: "red" }}
                    >
                      {"Password did not match"}
                    </p>
                  ) : (
                    ""
                  )
                }

                // endAdornment={
                //   <InputAdornment position="end">
                //     <IconButton
                //       aria-label="toggle password visibility"
                //       onClick={togglePasswords}
                //       onMouseDown={togglePasswords}
                //       name="hideConfPassword"
                //     >
                //       {hidePasswords.hideConfPassword ? (
                //         <Visibility />
                //       ) : (
                //         <VisibilityOff />
                //       )}
                //     </IconButton>
                //   </InputAdornment>
                // }

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePasswords}
                        onMouseDown={togglePasswords}
                        name="hideConfPassword"
                      >
                        {hidePasswords.hideConfPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            {message.length > 0 ? (
              <p
                style={{ textAlign: "center", margin: "10px 0" }}
                className={`text-${mesColor}`}
              >
                {t(message)}
              </p>
            ) : (
              ""
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              round
              color="secondary"
              onClick={toggleModal}
              style={{ width: "100px" }}
            >
              {t("Cancel")}
            </Button>
            <Button
              round
              color="primary"
              onClick={handleUpdate}
              style={{ width: "100px" }}
              disabled={disabledButton() || changePassword.isLoading}
            >
              {/* {value} */}
              <LoaderButton
                isLoading={changePassword.isLoading}
                spinner={spinner}
              >
                {t("Update")}
              </LoaderButton>
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  login: state.login,
  changePassword: state.changePassword,
});

export default connect(mapStateToProps, {
  updatePassword,
  resetChangePassword,
})(ChangePassword);
